/* MARVI OCEAN - Four4Luck pledge counter.
 *
 * The old page called window.storage, an API that does not exist in a browser
 * on this domain. Every read returned 0, every write went nowhere, and the
 * page told every visitor "1 person has answered honestly so far". Forever.
 *
 * This talks to a real Worker backed by Cloudflare KV.
 *
 * UNTIL WORKER_URL IS SET, NO NUMBER IS SHOWN AT ALL.
 * On a page whose entire premise is honesty, silence beats a fabricated
 * statistic. The pledge still works; it just does not claim a crowd.
 */
(function () {
  'use strict';

  /* PASTE YOUR WORKER URL HERE, e.g.
     var WORKER_URL = "https://marvi-four4luck.yourname.workers.dev"; */
  var WORKER_URL = "";

  var F4L = (window.F4LCount = {});

  F4L.enabled = function () { return !!WORKER_URL; };

  /* A stable per-browser id, so a refresh cannot inflate the count. */
  function clientId() {
    var k = 'marvi-f4l-client';
    try {
      var id = localStorage.getItem(k);
      if (!id) {
        var bytes = new Uint8Array(12);
        (window.crypto || window.msCrypto).getRandomValues(bytes);
        id = Array.prototype.map.call(bytes, function (b) {
          return ('0' + b.toString(16)).slice(-2);
        }).join('');
        localStorage.setItem(k, id);
      }
      return id;
    } catch (e) {
      return '';
    }
  }

  /* Has this browser already pledged? Keeps the UI honest across reloads. */
  F4L.myPledge = function () {
    try { return localStorage.getItem('marvi-f4l-pledge'); } catch (e) { return null; }
  };
  function remember(action) {
    try { localStorage.setItem('marvi-f4l-pledge', action); } catch (e) {}
  }

  function timeout(ms) {
    var c = typeof AbortController !== 'undefined' ? new AbortController() : null;
    setTimeout(function () { if (c) c.abort(); }, ms);
    return c;
  }

  /* Read the totals. Returns null on any failure: the caller shows nothing. */
  F4L.read = function () {
    if (!WORKER_URL) return Promise.resolve(null);
    var c = timeout(8000);
    return fetch(WORKER_URL, { signal: c ? c.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  };

  /* Record a pledge. action: 'in' | 'later' | 'answered' */
  F4L.send = function (action) {
    if (!WORKER_URL) return Promise.resolve(null);
    var id = clientId();
    if (!id) return Promise.resolve(null);

    var c = timeout(10000);
    return fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: action, clientId: id }),
      signal: c ? c.signal : undefined
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (d && (action === 'in' || action === 'later')) remember(action);
        return d;
      })
      .catch(function () { return null; });
  };

  /* 1247 -> "1,247" */
  F4L.format = function (n) {
    if (typeof n !== 'number' || !isFinite(n)) return null;
    return n.toLocaleString();
  };
})();
